export default {
  index: 'partner-staff-board-member-list-view',
  store: 'partner-staff-board-member-create-view',
  edit: 'partner-staff-board-member-edit-view',
};
